<form class="cat__app__profile__container card-body py-0" (ngSubmit)="onFormSubmit(f)" #f="ngForm" *ngIf="model">

    <div class="row">
        <div class="col-xl-12">
            <div class="form-group row py-0">
                <div class="col-12 col-xl-4 col-md-6 pl-xl-0">
                    <div class="d-flex flex-column form-group py-0">
                        <label class="form-control-label" for="profile-FirstName">Page title</label>
                        <input type="text"
                               name="firstName"
                               class="form-control"
                               [disabled]="isPastItemPage"
                               [(ngModel)]="model.pageTitle"
                               id="profile-FirstName">
                    </div>
                </div>

                <div class="col-12 col-xl-8 col-md-6 pl-xl-0">
                    <div class="d-flex flex-column form-group py-0">
                        <label class="form-control-label" for="profile-MiddleInitial">Page URL Key</label>
                        <span class="hint-text">(Only alphanumeric dash and underscore characters are valid)</span>
                        <input type="text"
                               name="middleInitial"
                               class="form-control max-width-500"
                               [disabled]="isPastItemPage"
                               [(ngModel)]="model.urlKey"
                               id="profile-MiddleInitial"
                               #urlKeyControl="ngModel"
                               pattern="^[a-zA-Z0-9-_]*$"
                               required
                               [maxlength]="urlKeyMaxLength()">
                        <div class="form-control-error url-key-form-control-error"
                             *ngIf="!urlKeyControl.valid && (urlKeyControl.touched || state.isSubmitted)">
                            <ul>
                                <li *ngIf="urlKeyControl?.errors?.pattern">Invalid URL Key.</li>
                                <li *ngIf="urlKeyControl?.errors?.required">URL Key s required.</li>
                                <li *ngIf="urlKeyControl?.errors?.maxlength">Can be up to {{urlKeyMaxLength()}} characters long.</li>
                            </ul>
                        </div>
                        <label class="form-control-label mb-2 mt-3 text-muted" for="profile-MiddleInitial">
                            <a (click)="hybridToolsService.openExternalLink(model?.fullUrl)" class="text-primary" target="_blank">{{model.baseUrl}}{{model.urlKey}}</a>
                        </label>
                    </div>
                </div>

            </div>
        </div>

        <div class="col-xl-12">
            <div class="form-group row py-0" *ngIf="!isNationalTeam">
                <div class="col-12 col-xl-4 col-md-6 pl-xl-0">
                    <div class="d-flex flex-column form-group py-0">
                        <label class="form-control-label" for="profile-LastName">How your name appears</label>
                        <input type="text"
                               name="lastName"
                               class="form-control"
                               [disabled]="isPastItemPage"
                               [(ngModel)]="model.displayName"
                               id="profile-LastName">
                    </div>
                </div>

                <div class="col-12 col-xl-4 col-md-6 pl-xl-0" *ngIf="!isNationalTeam">
                    <div class="d-flex flex-column form-group py-0">
                        <label class="form-control-label" for="profile-PostsNumber">Number of posts to show</label>
                        <select class="form-control"
                                name="number"
                                style="max-width:100px"
                                [disabled]="isPastItemPage"
                                #prefixType="ngModel"
                                [(ngModel)]="model.numberOfPostsDisplayed"
                                id="profile-PostsNumber">
                            <option class="form-check" *ngFor="let number of numbers" [ngValue]="number">
                                {{ number }}
                            </option>
                        </select>
                    </div>
                </div>

                <div class="col-12 col-xl-4 col-md-6 pl-xl-0" *ngIf="!isNationalTeam">
                    <div class="d-flex flex-column form-group py-0">
                        <label class="form-control-label">Participation</label>
                        <app-radio-button [disabled]="isPastItemPage" name="radioBasic" [(model)]="model.dedicationType"
                          options='[{"label":"Self", "value": "0"}, {"label": "In Honor", "value": "HONOR_OF"}, {"label": "In Memory", "value": "MEMORY_OF"}]'></app-radio-button>
                        <div class="d-flex flex-column form-group py-0 mt-3"
                             *ngIf="model?.dedicationType === 'HONOR_OF' || model?.dedicationType === 'MEMORY_OF'">
                            <label class="form-control-label" for="profile-NameOfPerson">Name of the person:</label>
                            <input type="text"
                                   name="NameOfPerson"
                                   class="form-control"
                                   required
                                   [disabled]="isPastItemPage"
                                   [(ngModel)]="model.honoree"
                                   id="profile-NameOfPerson">
                            <div class="form-control-error"
                                 *ngIf="!model.honoree && state.isSubmitted">
                                <ul>
                                    <li *ngIf="!model.honoree">Name is required.</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>


    <div class="row">
        <div class="col-12 pl-xl-0 mt-4" *ngIf="!isNationalTeam">
            <h5 class="text-black"><strong>Display on Page</strong></h5>
        </div>
    </div>

    <div class="row" *ngIf="!isNationalTeam">

        <div class="col-12 col-xl-4 col-md-6 pl-xl-0"
             *ngIf="cssClass === 'program-tnt'">
            <div class="d-flex flex-column form-group py-0">
                <label class="form-control-label">Fundraising goal</label>
                <app-radio-button [disabled]="isPastItemPage" name="PROGRESS_INDICATOR" [(model)]="displayOptions.PROGRESS_INDICATOR"
                  options='[{"label":"Show", "value": "PERSONAL_GOAL"}, {"label": "Minimum", "value": "FUNDRAISING_MINIMUM"}, {"label": "Hide", "value": "NO_THERMOMETER"}]'></app-radio-button>
            </div>
        </div>
        <div class="col-12 col-xl-4 col-md-6 pl-xl-0"
             *ngIf="cssClass!== 'program-tnt'
				&& cssClass !== 'program-mwoy'
				&& cssClass !== 'program-voy'
				&& cssClass !== 'program-soy'
				&& cssClass !== 'program-svoy'">
            <div class="d-flex flex-column form-group py-0">
                <label class="form-control-label">Fundraising goal</label>
                <app-radio-button [disabled]="isPastItemPage" name="PROGRESS_INDICATOR" [(model)]="displayOptions.PROGRESS_INDICATOR"
                  options='[{"label":"Show", "value": "PERSONAL_GOAL"}, {"label": "Hide", "value": "NO_THERMOMETER"}]'></app-radio-button>
            </div>
        </div>
        <div class="col-12 col-xl-4 col-md-6 pl-xl-0">
            <div class="d-flex flex-column form-group py-0">
                <label class="form-control-label">Contributors</label>
                <app-radio-button [disabled]="isPastItemPage" name="CONTRIBUTOR_LIST" [(model)]="displayOptions.CONTRIBUTOR_LIST"
                  options='[{"label":"All", "value": "ALL_CONTRIBUTORS"}, {"label": "Top 5", "value": "TOP_5_CONTRIBUTORS"}, {"label": "Hide", "value": "NO_CONTRIBUTORS"}]'></app-radio-button>
            </div>
        </div>
        <div class="col-12 col-xl-4 col-md-6 pl-xl-0"
             *ngIf="cssClass !== 'program-mwoy'
                    && cssClass !== 'program-voy'
                    && cssClass !== 'program-soy'
                    && cssClass !== 'program-svoy'
                    && !isNationalTeam">
            <div class="d-flex flex-column form-group py-0">
                <label class="form-control-label">Donation amount</label>
                <app-radio-button [disabled]="isPastItemPage" name="SHOW_DONATION_AMOUNT" 
                  [(model)]="displayOptions.SHOW_DONATION_AMOUNT" [options]='showHideOptions'></app-radio-button>
            </div>
        </div>

        <div class="col-12 col-xl-4 col-md-6 pl-xl-0"
             *ngIf="isTeam
                && cssClass !== 'program-mwoy'
                && cssClass !== 'program-voy'
			    && cssClass !== 'program-soy'
			    && cssClass !== 'program-svoy'">
            <div class="d-flex flex-column form-group py-0">
                <label class="form-control-label">Team Members Donation Page Links</label>
                <app-radio-button [disabled]="isPastItemPage" name="ALLOW_ROSTER_LINKS" 
                  [(model)]="displayOptions.ALLOW_ROSTER_LINKS" [options]='onOffOptions'>></app-radio-button>
            </div>
        </div>

        <!-- The news feed is only applicable to MWOY because the SOY template has no notion of it -->
        <div class="col-12 col-xl-4 col-md-6 pl-xl-0"
             *ngIf="cssClass === 'program-mwoy' || cssClass === 'program-voy'">
            <div class="d-flex flex-column form-group py-0">
                <label class="form-control-label">News feed</label>
                <app-radio-button [disabled]="isPastItemPage" name="SHOW_NEWS_FEED" [(model)]="displayOptions.SHOW_NEWS_FEED"
                  (change)="checkNewsFeedExists()" [options]='showHideOptions'></app-radio-button>
            </div>
        </div>
    </div>

    <div class="row" *ngIf="cssClass !== 'program-mwoy'
                        && cssClass !== 'program-voy'
		                && cssClass !== 'program-soy'
		                && cssClass !== 'program-svoy'
		                && !isNationalTeam">
        <div class="col-12 pl-xl-0 mt-4">
            <h5 class="text-black"><strong>Comments</strong></h5>
        </div>
    </div>

    <div class="row" *ngIf="cssClass !== 'program-mwoy'
                        && cssClass !== 'program-voy'
		                && cssClass !== 'program-soy'
		                && cssClass !== 'program-svoy'
		                && !isNationalTeam">
        <div class="col-12 col-xl-4 col-md-6 pl-xl-0">
            <div class="d-flex flex-column form-group py-0">
                <label class="form-control-label">Post comments</label>
                <app-radio-button [disabled]="isPastItemPage" name="ALLOW_POST_COMMENTS" [(model)]="displayOptions.ALLOW_POST_COMMENTS"
                  [options]='onOffOptions'></app-radio-button>
            </div>
        </div>
    </div>

    <div class="row" *ngIf="!isNationalTeam">
        <div class="col-12 pl-xl-0 mt-4">
            <h5 class="text-black"><strong>Notify me via email when:</strong></h5>
        </div>
    </div>

    <div class="row" *ngIf="!isNationalTeam">
        <div class="col-12 col-xl-4 col-md-6 pl-xl-0" *ngIf="cssClass !== 'program-mwoy'
			                                                && cssClass !== 'program-voy'
			                                                && cssClass !== 'program-soy'
			                                                && cssClass !== 'program-svoy'
			                                                && !isNationalTeam">
            <div class="d-flex flex-column form-group py-0">
                <label class="form-control-label">Someone comments on my posts</label>
                <app-radio-button [disabled]="isPastItemPage" name="SEND_POST_COMMENT_NOTIFICATION" [(model)]="displayOptions.SEND_POST_COMMENT_NOTIFICATION"
                  options='[{"label":"Yes", "value": "1"}, {"label": "No", "value": "0"}]'></app-radio-button>
            </div>
        </div>
        <div class="col-12 col-xl-4 col-md-6 pl-xl-0">
            <div class="d-flex flex-column form-group py-0">
                <label class="form-control-label">A new donation is made</label>
                <app-radio-button [disabled]="isPastItemPage" name="A_NEW_DONATION_MADE" [(model)]="model.notificationOptions.sendDonationNotification"
                  [options]='yesNoOptions'></app-radio-button>
            </div>
        </div>
        <div class="col-12 col-xl-4 col-md-6 pl-xl-0" *ngIf="cssClass !== 'program-mwoy'
			                                                && cssClass !== 'program-voy'
			                                                && cssClass !== 'program-soy'
			                                                && cssClass !== 'program-svoy'">
            <div class="d-flex flex-column form-group py-0">
                <label class="form-control-label">My fundraising minimum is met</label>
                <app-radio-button [disabled]="isPastItemPage" name="FUNDRAISING_MINIMUM" [(model)]="model.notificationOptions.sendMinimumMetNotification"
                  [options]='yesNoOptions'></app-radio-button>
            </div>
        </div>

        <div class="col-12 col-xl-4 col-md-6 pl-xl-0" *ngIf="cssClass !== 'program-mwoy'
			                                                && cssClass !== 'program-voy'
			                                                && cssClass !== 'program-soy'
			                                                && cssClass !== 'program-svoy'">
            <div class="d-flex flex-column form-group py-0">
                <label class="form-control-label">My fundraising goal is met</label>
                <app-radio-button [disabled]="isPastItemPage" name="FUNDRAISING_GOAL_MET" [(model)]="model.notificationOptions.sendGoalMetNotification"
                  [options]='yesNoOptions'></app-radio-button>
            </div>
        </div>

    </div>

    <div *ngIf="donationsAmounts?.length > 0">
        <div class="row" *ngIf="(cssClass === 'program-ltn' ||
                            cssClass === 'program-tnt'
                            || cssClass === 'program-regatta') && !isNationalTeam">
            <div class="col-12 pl-xl-0 mt-4">
                <h5 class="text-black"><strong>Donation Amounts</strong></h5>
            </div>
        </div>
        <div class="row mb-10" *ngIf="(cssClass === 'program-ltn' ||
                            cssClass === 'program-tnt'
                            || cssClass === 'program-regatta') && !isNationalTeam">

            <div class="col-12 pl-xl-0">
                <div class="d-flex flex-column form-group py-0">
                    <div class="form-check">
                        <label class="form-check-label d-block custom-control custom-radio"
                               [for]="amount.fundraiserPageDonationAmountRangeType.name"
                               *ngFor="let amount of donationsAmounts">
                            <input type="radio" class="custom-control-input"
                                   [name]="amount.fundraiserPageDonationAmountRangeType.name"
                                   [id]="amount.fundraiserPageDonationAmountRangeType.name"
                                   [value]="amount.fundraiserPageDonationAmountRangeType.name"
                                   [disabled]="isPastItemPage"
                                   [(ngModel)]="displayOptions.DONATION_AMOUNT_RANGE">
                            <span class="custom-control-label"></span>
                            <span class="custom-control-description">{{amount.fundraiserPageDonationAmountRangeType.description}}</span>
                            <span class="text-muted d-block">
                            (<span *ngFor="let item of amount.amounts; let idx = index">
                                <span *ngIf="item > 0">${{item}}<span *ngIf="idx < 5">, </span></span>
                            </span>)
                        </span>
                        </label>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="row mb-10">
        <div class="col-12 pl-xl-0">
            <div class="d-flex justify-content-end">
                <button type="submit"
                        [disabled]="isPastItemPage"
                        class="btn btn-primary">Save</button>
            </div>
        </div>
    </div>
</form>
